import { Component, Input, forwardRef, Output, EventEmitter, OnDestroy, OnInit, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BaseControlValueAccessor } from '../base-control-value-accessor';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DropdownItem } from 'mis-crystal-design-system/dropdown';
import { BookingsViewService } from 'src/app/bookings/bookings-view/bookings-view.service';

@Component({
    selector: 'app-select',
    templateUrl: './select.component.html',
    styleUrls: ['../../styles/form-input.scss', './select.component.scss'],
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => SelectComponent),
        multi: true
      }
    ]
})

export class SelectComponent extends BaseControlValueAccessor<any> implements OnInit, OnDestroy {

  @Input() formControl: FormControl;
  @Input() config: any;
  @Input() hasIcon: boolean;
  @Input() placeholder: string;
  @Input() showClear: boolean;
  @Input() hideOptionsList: any[] = [];
  @Input() type;
  @Input() isNonCompliantVisible = false;
  @Input() isNonCompliantSelectable = false;
  @Input() disableListElement = false;
  @Input() blockInitialChangeCallback: boolean;
  @Input() selectStyleApplied: string;
  @Input() itemSizeForCdk: number;
  @Input() styleApplied: string;
  @Input() customStyle: string;
  @Input() label = "Select";
  @Input() editRiderPhoneCode: any;
  @Input() getIconFromValue: (arg0: any) => string;
  @Input() getCustomOptionValue: (arg0: any) => string;
  @Input() getCustomOptionLabel: (arg0: any) => string;
  @Input() editableCostCenter = false;
  @Input() elementKey:string
  @Output() changeCallback = new EventEmitter();
  @Output() isPopupOpen = new EventEmitter<boolean>();
  @Output() assignDriverToVirtualCab = new EventEmitter<boolean>(false);
  isvirtualCabList = false;

  public canSearch: boolean;
  public canAdd: boolean;
  public isListShown = false;
  public selectOptions: Array<DropdownItem>;
  private searchQuery = '';
  public displayValue: string;
  private watcher: any;
  private optionList: any[];
  private initialChange = true;
  public activeOption: any;
  selectedItem: DropdownItem = { label: '', value: '', icon: '' };
  virtualCabIcon = "assets/ic-ui-virtual_cab.svg";
  complaintCabIcon = "assets/ic-ui-compliant_cab.svg";
  nonComplaintCabIcon = "assets/ic-ui-non_compliant_cab.svg";

// JSON = JSON;
  constructor(private elementRef: ElementRef,  private bookingViewService: BookingsViewService) {
    super();
  }

  @Input()
  set referenceValue(referenceValue: any) {
    if (!this.formControl) {
      this.setFormControlValue(referenceValue);
    }
  }

  @Input()
  set options(options: any) {
        this.optionList = options || [];
    this.filterOptions();
  }

  @Input()
  set hideOptions(options: any) {
    if (JSON.stringify(options) !== JSON.stringify(this.hideOptionsList)) {
      this.hideOptionsList = options || [];
      this.filterOptions();
    }
  }

  ngOnInit() {
    let data;


    if (this.optionList) {
      this.selectOptions =  this.optionList.sort();
    }
    if (this.selectOptions && this.selectOptions.length && this.config?.displayName == 'Cab Assign'){
      data = this.selectOptions.map((ele) => {
        return { label: this.getOptionLabel(ele), value: this.getOptionValue(ele), icon: this.getCabIcon(ele) };
      });
      this.selectOptions = data;
    }
    if (this.selectOptions && this.selectOptions.length  && this.config?.displayName !== 'Cab Assign') {
        data = this.selectOptions.map((ele) => {
          return { label: this.getOptionLabel(ele), value: this.getOptionValue(ele), icon: '' };
        });
        this.selectOptions = data;
                if (this.config?.displayName ===  'Billing Type' || this.config?.displayName ===  'Rider Type') {
        this.selectedItem = data[0];
      } else if (this.config?.displayName === 'Requester' ){
        this.selectedItem = data[1];
      } else if (this.config?.displayName === 'Boarding Type' ){
        this.selectedItem = data[0];
      } else if (this.config?.displayName === 'Name' ){
        this.selectedItem = data[0];
      } else {
                this.selectedItem = {label: this.label, value: 'Select' };
              }
        this.setOptions();
        if (this.formControl) {
        this.formControl.markAsPristine();
        this.watcher = this.formControl.valueChanges.subscribe(this.onFormControlChange.bind(this));
        if (this.formControl.value) {
          this.setFormControlValue(this.formControl.value);
          if (this.canSearch) {
            this.searchQuery = this.displayValue;
            this.filterOptions();
          }
        }
      }
    }
    if (this.editRiderPhoneCode) {
      this.formControl.setValue(this.editRiderPhoneCode?.currentState?.phoneCode);
    }


  }

  setFormControlValue(value: string) {
        if (value) {
      let optionFound = false;
      for (const option of this.optionList) {
        if (this.getOptionValue(option) && value &&
          (this.getOptionValue(option).toLowerCase() === value.toLowerCase()) &&
          this.value !== this.getOptionValue(option)) {
          this.setValue(this.getOptionValue(option));
          optionFound = true;
        }
      }
      if (!optionFound && value !== this.value) {
        this.setValue(value);
      }
    }
    if (!this.isvirtualCabList) { this.setDisplayValue(); }
    if (this.canSearch) {
      this.searchQuery = this.displayValue || '';
    }
  }

  onFormControlChange = (): void => {
    this.setFormControlValue(this.formControl.value);
  }

  setDisplayValue(): void {
    if (this.value) {
      for (const option of this.optionList) {
        if (this.getOptionValue(option) === this.value) {
          this.displayValue = this.getOptionLabel(option);
          this.selectedItem = { label: this.getOptionLabel(option), value: this.getOptionValue(option) };
          return;
        }
       /*  else {
          this.selectedItem =  { label:  '', value:  '' };
          return;
        } */
      }
    }
    this.displayValue = this.value;
    this.selectedItem =  { label:  this.getOptionLabel(this.value), value:  this.getOptionValue(this.value) };
  }

  setValue(value: string) {

    this.value = value;
    this.onChange(this.value);
    if (!this.isvirtualCabList) { this.setDisplayValue(); }
    if (this.blockInitialChangeCallback && !this.initialChange) {
      if (this.changeCallback) {
        // this.changeCallback.emit('+358');
        this.changeCallback.emit(this.value);
      }
    } else if (!this.blockInitialChangeCallback) {
      if (this.changeCallback) {
        // this.changeCallback.emit('+358');
        this.changeCallback.emit(this.value);
      }
    }
    if (this.initialChange) {
      this.initialChange = false;
    }
  }

  onOptionClick(e: DropdownItem): void {

    if (this.config?.displayName == 'Cab Assign' && e.icon == this.virtualCabIcon){
     this.assignDriverToVirtualCab.emit(true);
    }
    this.selectedItem = e;
    const option = e.value;
    if (option?.['virtual']) {
      // this.showCabDetails =  true;
      if (this.isPopupOpen) {
        this.isPopupOpen.emit(true);
        this.isvirtualCabList = true;
      } else {
        this.isvirtualCabList = false;
      }
    } else {
      this.isvirtualCabList = false;
      this.hideList();
      this.setValue(option);
      // this.setValue(this.getOptionValue(option));
    }
    this.setValue(option);
    // this.setValue(this.getOptionValue(option));
    this.setOptions();
  }

  getOptionValue(option: any): string {
    if (this.getCustomOptionValue) {
      return this.getCustomOptionValue(option);
    }
    return option;
  }

  getOptionLabel(option: any): string {
    this.setOptions();
    if (this.getCustomOptionLabel) {
      return this.getCustomOptionLabel(option);
    }
    return option;
  }

  getOptionImage(option: any): string {
    return this.getIconFromValue(this.getOptionValue(option));
  }

  showError(): boolean {
    return Boolean(this.formControl && this.formControl.errors && this.formControl.dirty);
  }

  setOptions(): void {
    switch (this.type) {
      case 'dropdown':
        this.canSearch = false; this.canAdd = false;
        this.placeholder = this.placeholder || 'Select';
        break;
      case 'dropdownAndInput':
        this.canSearch = false; this.canAdd = true;
        this.placeholder = this.placeholder || 'Select or enter';
        break;
      case 'dropdownAndSearch':
        this.canSearch = true; this.canAdd = false;
        this.placeholder = this.placeholder || 'Select';
        break;
      case 'dropdownAndSearchAndInput':
        this.canSearch = true; this.canAdd = true;
        this.placeholder = this.placeholder || 'Select or enter';
        break;
      default: console.warn('Incorrect dropdown type', this.type);
    }

  }

  handleTriggerClick(e: Event) {
    if (this.formControl && this.formControl.disabled) {
      return;
    }
    if (!this.isListShown) {
      this.showList();
    } else if (this.isListShown && !this.canAdd) {
      this.hideList();
    }
  }

  handleInputChange(event ?: any) {
    if (this.canSearch) {
      this.searchQuery = this.displayValue;
      this.filterOptions();
    }

    if (this.canAdd) {
      this.setValue(this.getValueFromDisplayValue());
    }

    if (event && event.keyCode === 13 && typeof this.activeOption === 'number') {
      this.setValue(this.getOptionValue(this.selectOptions[this.activeOption]));
      this.hideList();
    } else if (event && event.keyCode === 13 && this.isListShown) {
      this.hideList();
    } else if (!event || event.keyCode !== 27) {
      this.showList();
    }
  }

  preventEnterKeyBehaviour(event) {
    // enter key triggers a click outside event by default
    if (event.keyCode === 13) {
      event.preventDefault();
    }
  }

  handleClickEvent() {
    this.filterOptions();
  }


  setHighlightedOption(event) {
    if (event && event.keyCode === 40) {
      // down arrow key triggers a page scroll by default
      event.preventDefault();
      this.activeOption = (typeof this.activeOption === 'number' && this.activeOption < this.selectOptions.length - 1)
                            ? (this.activeOption + 1) : 0;
      this.scrollToActiveOption();
    } else if (event && event.keyCode === 38) {
      // up arrow key triggers a page scroll by default
      event.preventDefault();
      this.activeOption = (typeof this.activeOption === 'number' && this.activeOption > 0)
                            ? (this.activeOption - 1) : this.selectOptions.length - 1;
      this.scrollToActiveOption();
    } else if (event && (event.keyCode === 9 || event.keyCode === 27)) {
      this.hideList();
    }
  }

  scrollToActiveOption() {
    const parent = this.elementRef.nativeElement;
    parent.getElementsByClassName('select-option')[this.activeOption].scrollIntoView({block: 'nearest'});
  }

  getValueFromDisplayValue(): string {
    let displayValue: string;
    if (this.displayValue){
      displayValue = this.displayValue.toLowerCase().trim();
    }
    for (const option of this.optionList) {
      if (this.getOptionLabel(option).toLowerCase() === displayValue) {
        return this.getOptionValue(option);
      }
    }
    return this.canAdd ? this.displayValue :  '';
  }

  filterOptions() {
    if (this.optionList && this.optionList.length) {   
        const data = this.optionList.filter((option) => {
        const label = this.getOptionLabel(option);
        // const matchedSearch =  label.indexOf(this.searchQuery.toLowerCase()) > -1;
        let isHidden = false;
        for (const hideOption of this.hideOptionsList) {
          if (this.getOptionValue(hideOption) === this.getOptionValue(option)) {
            isHidden = true;
          }
        }
        return !isHidden ;
      });


        if (this.config?.displayName == 'Cab Assign' && this.selectOptions) {
        this.selectOptions = [];
        data.forEach(ele => {
          if (this.selectOptions.indexOf(ele) < 0){
          this.selectOptions.push(
            {
              label: this.getOptionLabel(ele),
              value: this.getOptionValue(ele),
              icon: this.getCabIcon(ele)
            }
          );
          }
        });
      }
      else{
        this.selectOptions   = data.map((ele) => {
          return { label: this.getOptionLabel(ele), value: this.getOptionValue(ele) };
        });
      }
    }

    this.bookingViewService.clearUpdate.subscribe(res => {
      if (res){
         this.handleInputBlur();
         this.selectedItem = {label: '', value: '', };
         this.label = 'Select';
      }
    });

 /*    if(this.optionList && this.optionList.length) {
      let data = this.optionList.filter((option) => {
          const label = this.getOptionLabel(option).toLowerCase();
          const matchedSearch =  label.indexOf(this.searchQuery.toLowerCase()) > -1;
          let isHidden = false;
          for (const hideOption of this.hideOptionsList) {
            if (this.getOptionValue(hideOption) === this.getOptionValue(option)) {
              isHidden = true;
            }
          }
          return !isHidden && matchedSearch;
        });
        if(this.config?.displayName === 'Cab Type') {
            this.selectOptions = data.map((ele) => {
          return { label: this.getOptionLabel(ele), value: this.getOptionValue(ele) }
        });
        } else {
          this.selectOptions = data;
        }

    } */
  }

  getCabIcon(ele) {
    switch (true) {
      case ele['virtual'] :
      return this.virtualCabIcon;
      case ele['compliant']:
      return this.complaintCabIcon;
      default:
      return this.nonComplaintCabIcon;
    }
    }

  handleInputBlur() {
    // this.label='Select'
    if (!this.value) {
      this.displayValue = '';
      // this.handleInputChange();
    } else if (!this.displayValue && this.value) {
      this.setValue('');
    } else {
      this.setDisplayValue();
    }
  }

  showList() {
    this.isListShown = true;
  }

  hideList() {
    this.isListShown = false;
    this.activeOption = undefined;
  }

  clickOutside() {
      this.isListShown = false;
  }

  clearInput(event) {
    event.stopPropagation();
    this.setValue('');
  }

  getStyle() {
    const displayName = this.config?.displayName;
    switch (displayName) {
      case 'Gender': {
        if ( this.styleApplied !== 'editable-table' || this.selectStyleApplied === 'editable-table') {
          return 'mis-dropdown-56';
        } else {
          return 'gender';
        }
      }
      case 'City': {
        if ( this.styleApplied !== 'editable-table' || this.selectStyleApplied === 'editable-table') {
          return 'mis-dropdown-56';
        } else {
          return 'mis-dropdown-32';
        }
      }
      case 'Booking Type': {
        if ( this.styleApplied !== 'editable-table' || this.selectStyleApplied === 'editable-table') {
          return 'mis-dropdown-56';
        } else {
          return 'mis-dropdown-32';
        }
      }
      case 'Cab Type': {
        if ( this.styleApplied !== 'editable-table' || this.selectStyleApplied === 'editable-table') {
          return 'mis-dropdown-56';
        } else {
          return 'mis-dropdown-32';
        }
      }
      case 'Vendor': {
        if ( this.styleApplied !== 'editable-table' || this.selectStyleApplied === 'editable-table') {
          return 'mis-dropdown-56';
        } else {
          return 'mis-dropdown-32';
        }
      }
      case 'Cost Center': {
        if (this.selectStyleApplied !== 'editable-table') {
          return 'mis-dropdown-56';
        } else {
          return 'costCenterName';
        }
    }
      case 'PhoneCode': {
        if (this.selectStyleApplied !== 'editable-table') {
          return 'mis-dropdown-56';
        } else {
          return 'phonecodeDropdown';
        }
      }
      case 'Select Option': return 'billing-select-option';
      case 'Billing Type': return 'billing-type-dropdown';
      case 'Requester': return 'requester-dropdown';
      case 'Rider Type': return 'rider-type-dropdown';
      case 'Name': return 'name-dropdown';
      case 'Boarding Type': return 'boarding-type';
      case 'Cab Assign': return 'booking-cab-assign';
      case 'Driver Assign': return 'booking-cab-assign';
      default: return '';
    }
  }

  onClickSelectDropdown(){
    // if(this.formControl.disabled==true) this.formControl.enable()
  }
  ngOnDestroy() {
    if (this.watcher) {
      this.watcher.unsubscribe();
    }
    if (this.formControl) {
      this.formControl.updateValueAndValidity({emitEvent: false});
    }
  }

}
